import { Button, Row } from "@narmi/design_system";
import { Dialog } from "cerulean";
import { useLocalization } from "@fluent/react";

export type CancelPaymentDialogType = {
  isOpen: boolean;
  handleClose: () => void;
  handleCancel: () => void;
  isBulk?: boolean;
};

const CancelPaymentDialog = ({
  isOpen,
  handleClose,
  handleCancel,
  isBulk = false,
}: CancelPaymentDialogType) => {
  const { l10n } = useLocalization();

  const handleCancelPayment = () => {
    handleCancel();
  };

  return (
    <Dialog
      width={isBulk ? "440px" : "385px"}
      isOpen={isOpen}
      onUserDismiss={handleClose}
      title={
        isBulk
          ? l10n.getString("cancel-bulk-dialog-title")
          : l10n.getString("cancel-payment-dialog-title")
      }
      footer={
        <Row alignItems="center">
          <Row.Item>
            <Button kind="plain" onClick={handleClose} testId="bulk-dialog-go-back">
              {l10n.getString("label-go-back")}
            </Button>
          </Row.Item>
          <Row.Item shrink>
            <Button onClick={handleCancelPayment} testId="bulk-dialog-cancel-payment">
              {isBulk
                ? l10n.getString("label-cancel-bulk")
                : l10n.getString("label-cancel-payment")}
            </Button>
          </Row.Item>
        </Row>
      }
    >
      <span className="margin--bottom--xl">
        {isBulk
          ? l10n.getString("cancel-bulk-dialog-content")
          : l10n.getString("cancel-payment-dialog-content")}
      </span>
    </Dialog>
  );
};

export default CancelPaymentDialog;
